import mitt from 'mitt';
/**
 *事件总线
 */
export const BUS = mitt();
/**
 * 判断设备是不是移动端设备
 */
const isIOS = () => {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
  }
};
export const isMobile = () => {
  if (isIOS()) return true;
  let userAgent = navigator.userAgent,
    Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  return Agents.some((i) => {
    return userAgent.includes(i);
  });
};

export const isElectron = () => {
  return /electron/i.test(navigator.userAgent.toLowerCase());
};

/**
 * 屏蔽/resource下载入口
 * @param {arr} arr 菜单arr树形结构
 * @param {string} attr 要检索的属性
 * @returns arr
 */
const filterResource = (arr, attr) => {
  if (!(Array.isArray(arr) && arr.length)) return arr;
  for (let i = 0; i < arr.length; i++) {
    const child = arr[i];
    if (child && child[attr]) {
      filterResource(child[attr], attr);
    } else {
      if (child.path === '/resource') {
        arr.splice(i, 1);
      }
    }
  }
  return arr;
};

// 抖音屏蔽下载入口
export const filterDownloadMenu = (menuConfig = []) => {
  let result = filterResource(menuConfig, 'childrens');
  result = filterResource(menuConfig, 'mobileChildrens');
  return result;
};
